$(function() {
  $("#new_address :input").change(() => $('#verified').val(false));
  $('#newAddressBtn').click(() => $('#new_address').submit());
  $('#upsAddressBtn').click(() => $('#upsAddress').submit());
});
